var _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcoChannel9(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 10.8,
    height: 10.8,
    rx: 1,
    fill: "#B1B1B1"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    y: 12.6,
    width: 10.8,
    height: 10.8,
    rx: 1,
    fill: "#B1B1B1"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    y: 25.2,
    width: 10.8,
    height: 10.8,
    rx: 1,
    fill: "#B1B1B1"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 12.6001,
    width: 10.8,
    height: 10.8,
    rx: 1,
    fill: "#B1B1B1"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 12.6001,
    y: 12.6,
    width: 10.8,
    height: 10.8,
    rx: 1,
    fill: "#B1B1B1"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 12.6001,
    y: 25.2,
    width: 10.8,
    height: 10.8,
    rx: 1,
    fill: "#B1B1B1"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 25.2,
    width: 10.8,
    height: 10.8,
    rx: 1,
    fill: "#B1B1B1"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 25.2,
    y: 12.6,
    width: 10.8,
    height: 10.8,
    rx: 1,
    fill: "#B1B1B1"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 25.2,
    y: 25.2,
    width: 10.8,
    height: 10.8,
    rx: 1,
    fill: "#B1B1B1"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoChannel9);
export default __webpack_public_path__ + "static/media/ico-channel-9.276f26c5f586b82ef6fc8eebe7301f60.svg";
export { ForwardRef as ReactComponent };